import React from "react";
import { Plus } from "lucide-react";

const FAQS = [
  {
    q: "Wer ist der beste Burger in Stuttgart 2026?",
    a: "Der Testsieger Best Burger Stuttgart 2026 ist BUDDIEZ buns & rolls in der Werderstr. 79, 70190 Stuttgart. Mit einer Gesamtwertung von 9,7 / 10 setzte sich BUDDIEZ buns & rolls im direkten Vergleich gegen 47 weitere Stuttgarter Burger-Restaurants durch.",
  },
  {
    q: "Wie wurde der Stuttgart Burger Test 2026 durchgeführt?",
    a: "Der Burger Stuttgart Test lief über drei Monate (Januar bis März 2026). Eine Jury aus Food-Journalist:innen, Köch:innen und Stammgästen bewertete jeden Kandidaten nach zwölf Kriterien: Patty-Qualität, Bun, Sauce, Toppings, Fritten, Preis-Leistung, Ambiente, Service, Konsistenz, Herkunft der Zutaten, Innovation und Wiederkehr-Faktor.",
  },
  {
    q: "Warum ist BUDDIEZ buns & rolls der beste Burger in Stuttgart?",
    a: "BUDDIEZ punktet mit einem smashed Patty aus regionalem Dry-Aged-Beef, einem eigens entwickelten Butter-Brioche-Bun und einer Sauce, die Jury und Community gleichermaßen überzeugte. Die Fritten - einmal dünn, einmal dick - gelten bei vielen Stuttgarter:innen als Stadtbeste.",
  },
  {
    q: "Wo gibt es BUDDIEZ buns & rolls in Stuttgart?",
    a: "BUDDIEZ buns & rolls findest du in der Werderstr. 79, 70190 Stuttgart (Stuttgart-Ost). Google Maps: Werderstr. 79, 70190 Stuttgart.",
  },
  {
    q: "Wie bekomme ich die Gratis-Portion Fritten?",
    a: "Trage deine E-Mail-Adresse im Formular auf dieser Seite ein. Du erhältst umgehend einen digitalen Gutschein für eine gratis Portion Fritten bei deinem nächsten Besuch im Testsieger BUDDIEZ buns & rolls. Nur 1x pro Person einlösbar.",
  },
  {
    q: "Welche Burger-Restaurants in Stuttgart haben es noch in die Top 10 geschafft?",
    a: "Neben BUDDIEZ buns & rolls (Platz 1) schafften es Burgermeister (Stadtmitte), Hob's Burger (Bad Cannstatt), Goldies, Bo's Burger (West), Smash it Burger (Bad Cannstatt), Better Burger Company, Meatery, Mrs. Wood und Hans im Glück in die Top 10 des Stuttgart Burger Rankings 2026.",
  },
];

export default function FAQ() {
  return (
    <div className="divide-y divide-zinc-900 border-y border-zinc-900" data-testid="faq-section">
      {FAQS.map((f, i) => (
        <details key={i} className="group" data-testid={`faq-${i}`}>
          <summary className="flex items-start justify-between gap-6 py-5 cursor-pointer list-none">
            <h3 className="font-editorial-soft text-xl sm:text-2xl text-white leading-snug pr-4">
              {f.q}
            </h3>
            <Plus className="w-5 h-5 mt-1 shrink-0 text-[#E8B14A] transition-transform duration-300 group-open:rotate-45" />
          </summary>
          <p className="pb-6 pr-10 text-zinc-400 text-base leading-relaxed">{f.a}</p>
        </details>
      ))}
    </div>
  );
}
